import axios from 'axios'

const Axios = axios.create({
  // baseURL: 'http://localhost:8880/',
  baseURL: 'https://caspian-hr.lemueltech.com/',
  
  // withCredentials: true
})

export default Axios;
